<template>
  <div class="app-navbar-actions">
    <VaButton icon="add" @click="handleSubmitRequest" class="new-audience-button">
      <span class="button-text-full">New Audience Request</span>
      <span class="button-text-short">New Request</span>
    </VaButton>
    <SubmitRequestModal v-model="showRequestModal" type="All" @submit="handleRequestSubmit" />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import SubmitRequestModal from '../../audience-request/SubmitRequestModal.vue'
import { useNotifications } from '../../../composables/useNotifications'

const props = defineProps({
  isMobile: { type: Boolean, default: false },
})

const { showSuccess, showError } = useNotifications()
const showRequestModal = ref(false)

const handleSubmitRequest = () => {
  showRequestModal.value = true
}

const handleRequestSubmit = async (data: { email: string; url: string; type: string }) => {
  try {
    const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || ''
    const baseUrl = apiBaseUrl.endsWith('/') ? apiBaseUrl.slice(0, -1) : apiBaseUrl
    const apiPath = baseUrl ? `${baseUrl}/api/audience-requests` : '/api/audience-requests'

    const response = await fetch(apiPath, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: data.email,
        url: data.url,
        type: data.type,
      }),
    })

    if (!response.ok) {
      throw new Error(`Failed to submit request: ${response.status} ${response.statusText}`)
    }

    await response.json()

    showSuccess('Request submitted successfully! You will be notified via email when the audience data is ready.')
    showRequestModal.value = false
  } catch (err) {
    console.error('Error submitting request:', err)
    showError(err instanceof Error ? err.message : 'Failed to submit request. Please try again.')
  }
}
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;
  margin-right: 1rem;

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    padding: 0;
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    svg {
      height: 20px;
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 640px) {
      margin-left: 0;
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }

  .new-audience-button {
    white-space: nowrap;
  }

  .button-text-short {
    display: none;
  }

  @media screen and (max-width: 640px) {
    .button-text-full {
      display: none;
    }

    .button-text-short {
      display: inline;
    }
  }
}
</style>
